/* eslint-disable class-methods-use-this */
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import { UploadType } from '../../../enums/upload-type.enum';
import { LMSCourseService } from '../../../services/lms-courses/lms-course.service';
import { LmsCourseAPIResponse } from '../../../types/responses/lms-course.responses';

@Component({
  selector: 'app-lms-course-file-list',
  templateUrl: './lms-course-file-list.component.html',
  styleUrls: ['./lms-course-file-list.component.scss'],
  standalone: false,
})
export class LmsCourseFileListComponent implements OnInit, OnChanges {
  @Input() uploadType: UploadType = UploadType.USER_UPLOAD;

  @Input() fileList: LmsCourseAPIResponse[];

  @Output() readonly deletedFile = new Subject<LmsCourseAPIResponse>();

  errorMessage: string;

  public internalList: LmsCourseAPIResponse[] = [];

  constructor(private lmsCourseService: LMSCourseService) {}

  viewFile(file: LmsCourseAPIResponse) {
    window.open(file.preview_link, '_blank');
  }

  ngOnInit() {
    if (this.fileList) {
      this.internalList = this.fileList;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileList']) {
      if (
        changes['fileList'].currentValue !== changes['fileList'].previousValue
      ) {
        this.internalList = this.fileList;
      }
    }
  }

  fileListUpdate() {
    this.internalList = this.fileList;
  }

  deleteFile(file: LmsCourseAPIResponse) {
    this.lmsCourseService.deleteCourse(file.id).subscribe({
      next: () => {
        this.deletedFile.next(file);
        this.internalList = this.internalList.filter((f) => f.id !== file.id);
      },
      error: (error) => {
        this.errorMessage = error.error?.message || 'Failed to delete file';
      },
    });
  }
}
